import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeCalendarServiceService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  onGetTimeSlots(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetTimeSlots');
  }
  onCheckVisitorExists(params: any): Observable<any> {
    return this.cyclopsHttp.post('CheckExistingVisitor', params);
  }
  onCreateNewVisitorInvite(params: any): Observable<any> {
    return this.cyclopsHttp.post('AddVisitor', params);
  }
  onGetHostsList(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetHostList');
  }
  onVerifyHostVisitor(params: any): Observable<any> {
    return this.cyclopsHttp.post('FaceRecognition', params);
  }
}
